import { useAppDispatch } from 'app/redux';
import { useLoginMutation } from 'common/api/endpoints/auth';
import { useCallback } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { determinePathOnLogin } from 'utils/helperFunction';
import * as authLocalStorage from '../authLocalStorage';
import { authSlice } from '../authSlice';

export interface Credentials {
  email: string;
  password: string;
}

export type UseLoginHook = () => {
  login: (credentials: Credentials) => Promise<void>;
  isLoading: boolean;
};

export const useLogin: UseLoginHook = () => {
  const history = useHistory();
  const dispatch = useAppDispatch();
  const { state: routerState } = useLocation<{ redirectTo?: string }>();

  const [login, { isLoading }] = useLoginMutation();

  const loginUser = useCallback(
    async (credentials: Credentials) => {
      const session = await login(credentials).unwrap();
      const auth = { token: session.token, user: session.user };

      dispatch(authSlice.actions.userLoggedIn(auth));
      authLocalStorage.saveAuthState(auth);

      if (routerState?.redirectTo) {
        history.push({
          pathname: routerState.redirectTo,
          state: { redirectTo: undefined },
        });
      } else {
        history.push(determinePathOnLogin(session.user.role.roleName));
      }
    },
    [login, dispatch, routerState, history],
  );

  return { login: loginUser, isLoading };
};
